/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const INTERVAL = feature.getSettingValue('INTERVAL');
    const NAME = `timer_${feature.getID()}`;
    const tickLinks = project.getNodeLinks(feature, 'timer_tick');

    let iterruptCode = '';

    if (tickLinks.length > 0) {
        const link = tickLinks[0];

        iterruptCode += `#****${link.getSourceId()}****#`;
    }

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
def timer_${NAME}():
    while True:
        try:
            ${iterruptCode}
            pass
        except Exception as e:
            print(e)
            pass
        await asyncio.sleep_ms(${(Number(INTERVAL) * 1000).toString()})
        ${iterruptCode}`,
    });

    blocks.push({
        location: 'ASYNC_TASKS',
        blockType: BlockType.CODE,
        template: `
loop = asyncio.get_event_loop()
loop.create_task(timer_${NAME}())`,
    });

    return blocks;
};
